import React from 'react';
import Header from '../components/Header';
import HeroSection from '../components/HeroSection';
import GallerySection from '../components/GallerySection';
import AboutSection from '../components/AboutSection';
import TeamSection from '../components/TeamSection';
import EventCalendar from '../components/EventCalendar';
import FacebookFeed from '../components/FacebookFeed';
import PublicChatSection from '../components/PublicChatSection';
import PublicLocationsSection from '../components/PublicLocationsSection';
import Footer from '../components/Footer';
import { SHOW_ZELLO_SECTIONS } from '../lib/featureFlags';

const LandingPage = () => {
  return (
    <div className="bg-black min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <GallerySection />
        <AboutSection />
        <TeamSection />
        <EventCalendar />
        <FacebookFeed />
        {SHOW_ZELLO_SECTIONS && <PublicChatSection />}
        {SHOW_ZELLO_SECTIONS && <PublicLocationsSection />}
      </main>
      <Footer />
    </div>
  );
};

export default LandingPage;
